import React from "react";

const Java_Keywords = () => {
  return (
    <div>
      <h1>Java Keywords</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Keywords in Java.</p>
    </div>
  );
};

export default Java_Keywords;
